<div id="img-cont" class="dsk">
  <img src="../../../assets/AU-blr.png" alt="" class="logo-blr" />
  <!-- <div style="margin-top: 8px;"> -->
  <!-- <div> -->
  <!-- <span>Supported By:</span> -->
  <img src="../../../assets/3x/AII_supportedBy.png" alt="" class="logo-inc" />
  <!-- </div> -->
  <!-- </div> -->

  <!-- <div> -->
  <!-- <img src="../../../assets/Applab.png" alt="" class="app-lab-logo" style="margin-left:0px ;"/>   -->
  <!-- </div> -->
  <!-- <span class="vertical_dotted_line"></span> -->
  <!-- <div> -->
  <!-- <img src="../../../assets/AIMLogo2.png" alt="" class="aim-logo" style="float: right;" /> -->
</div>


<div class="glass"></div>
<div id="mb-logos" class="mb" style="z-index: 2"></div>
<!-- <div style="position:relative;">
    <div class="glass">
    </div>
</div> -->